"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as e, Fragment as F } from "react/jsx-runtime";
import * as x from "react";
import { createElement as X } from "react";
import { Transition as Y } from "react-transition-group";
import u from "classnames";
import f from "./responsive-layout.js";
import N from "./inline.js";
import Z, { BaseTouchable as P } from "./touchable.js";
import { Text3 as _, Text2 as ee } from "./text.js";
import { useTheme as C, useAriaId as ne, useScreenSize as re } from "./hooks.js";
import te from "./generated/mistica-icons/icon-menu-regular.js";
import ae from "./generated/mistica-icons/icon-close-regular.js";
import oe from "./generated/mistica-icons/icon-chevron-left-regular.js";
import { IconButton as ie } from "./icon-button.js";
import se from "./negative-box.js";
import { RowList as ce, Row as le } from "./list.js";
import { ThemeVariant as S, useIsInverseVariant as de } from "./theme-variant-context.js";
import G from "./focus-trap.js";
import { Portal as me } from "./portal.js";
import ue from "./grid-layout.js";
import { useSetModalState as pe } from "./modal-context-provider.js";
import { Logo as z } from "./logo.js";
import { vars as H } from "./skins/skin-contract.css-mistica.js";
import { mainNavbarContent as he, burgerMenuButton as ge, logoContainer as fe, spacerLarge as ve, spacer as T, burgerMenu as Ne, burgerMenuTransition as be, lineHeightFix as U, textWrapperVariants as j, burgerIconContainer as Be, iconCloseOpen as Me, iconCloseHidden as ke, iconMenuHidden as xe, iconMenuOpen as Ce, topFixed as Se, navigationBarContent as Te, desktopOnly as $, navigationBarContentRight as Ae, section as Ie, selectedSectionVariantes as Oe, navbarBorderColorVariants as k } from "./navigation-bar.css-mistica.js";
import { sprinkles as W } from "./sprinkles.css-mistica.js";
import { getPrefixedDataAttributes as Re } from "./utils/dom.js";
import ye from "./stack.js";
import Ee from "./box.js";
import { isRunningAcceptanceTest as Le } from "./utils/platform.js";
const we = (param)=>{
    let { isOpen: n } = param;
    return /* @__PURE__ */ i("div", {
        className: Be,
        role: "presentation",
        "data-component-name": "BurgerMenuIcon",
        children: [
            /* @__PURE__ */ e("div", {
                className: n ? Me : ke,
                children: /* @__PURE__ */ e(ae, {})
            }),
            /* @__PURE__ */ e("div", {
                className: n ? xe : Ce,
                children: /* @__PURE__ */ e(te, {})
            })
        ]
    });
}, De = 300, A = (param)=>{
    let { children: n, topFixed: a, withBorder: t, isMenuOpen: r, isInverse: o, dataAttributes: s } = param;
    const { isDarkMode: c } = C();
    return /* @__PURE__ */ e("header", _object_spread_props(_object_spread({
        className: u((()=>o && !c || !t ? k.noBorder : r ? k.menuOpen : k.default)(), {
            [Se]: a
        }),
        style: {
            background: o ? H.colors.navigationBarBackground : H.colors.background
        }
    }, Re(s)), {
        children: n
    }));
}, v = (param)=>{
    let { right: n, children: a, desktopOnly: t } = param;
    return /* @__PURE__ */ i("div", {
        className: u(Te, {
            [$]: t
        }),
        children: [
            a,
            n && /* @__PURE__ */ e("div", {
                className: Ae,
                children: n
            })
        ]
    });
}, mn = (param)=>{
    let { sections: n = [], selectedIndex: a, right: t, isInverse: r = !1, topFixed: o = !0, withBorder: s = !0, burgerMenuExtra: c, logo: l, large: p = !1 } = param;
    const { texts: m, isDarkMode: q } = C(), [d, I] = x.useState(!1), [O, h] = x.useState("closed"), R = ne(), J = q ? 1 : 0.2, { isTabletOrSmaller: K } = re(), y = pe();
    l = l !== null && l !== void 0 ? l : /* @__PURE__ */ e(z, {
        size: {
            mobile: 40,
            desktop: 48
        }
    });
    const E = ()=>/* @__PURE__ */ e("nav", {
            className: $,
            children: /* @__PURE__ */ e(N, {
                space: 32,
                children: n.map((_param, g)=>{
                    var { title: B } = _param, M = _object_without_properties(_param, [
                        "title"
                    ]);
                    return /* @__PURE__ */ /*#__PURE__*/ X(P, _object_spread_props(_object_spread({}, M), {
                        key: g,
                        className: u(Ie, {
                            [Oe[r ? "inverse" : "default"]]: g === a
                        }, j[r ? "inverse" : "default"])
                    }), /* @__PURE__ */ e(_, {
                        regular: !0,
                        color: "inherit",
                        children: B
                    }));
                })
            })
        }), b = p && n.length > 0, Q = ()=>{
        I(!0), y({
            isModalOpen: !0
        });
    }, L = ()=>{
        I(!1), y({
            isModalOpen: !1
        });
    }, w = O !== "open", D = n.length > 1, V = /* @__PURE__ */ i(S, {
        isInverse: r,
        children: [
            /* @__PURE__ */ e(A, {
                topFixed: o,
                withBorder: s,
                isMenuOpen: d,
                isInverse: r,
                dataAttributes: {
                    "component-name": "MainNavigationBar"
                },
                children: /* @__PURE__ */ i(f, {
                    children: [
                        /* @__PURE__ */ e(v, {
                            right: t,
                            children: /* @__PURE__ */ i("div", {
                                className: he,
                                children: [
                                    D && /* @__PURE__ */ e(Z, {
                                        className: ge,
                                        "aria-live": "polite",
                                        "aria-label": d ? m.closeNavigationMenu : m.openNavigationMenu,
                                        "aria-expanded": d,
                                        "aria-controls": R,
                                        onPress: d ? L : Q,
                                        children: /* @__PURE__ */ e(we, {
                                            isOpen: d
                                        })
                                    }),
                                    /* @__PURE__ */ e("div", {
                                        className: fe,
                                        children: l
                                    }),
                                    !b && E()
                                ]
                            })
                        }),
                        b && /* @__PURE__ */ e(v, {
                            desktopOnly: !0,
                            children: E()
                        })
                    ]
                })
            }),
            o && /* @__PURE__ */ e("div", {
                className: b ? ve : T
            })
        ]
    });
    return K ? /* @__PURE__ */ i(F, {
        children: [
            /* @__PURE__ */ e(G, {
                disabled: w,
                group: "burger-menu-lock",
                children: V
            }),
            D && /* @__PURE__ */ e(me, {
                children: /* @__PURE__ */ e(G, {
                    disabled: w,
                    group: "burger-menu-lock",
                    children: /* @__PURE__ */ e(Y, {
                        onEntering: ()=>{
                            h("opening");
                        },
                        onEntered: ()=>{
                            h("open");
                        },
                        onExiting: ()=>{
                            h("closing");
                        },
                        onExited: ()=>{
                            h("closed");
                        },
                        in: d,
                        timeout: Le() ? 0 : De,
                        unmountOnExit: !0,
                        children: (B)=>/* @__PURE__ */ e(F, {
                                children: /* @__PURE__ */ e("nav", {
                                    className: u(Ne, be[B]),
                                    style: {
                                        boxShadow: O !== "closed" ? `6px 0 4px -4px rgba(0, 0, 0, ${J})` : "none"
                                    },
                                    id: R,
                                    onClick: ()=>{
                                        L();
                                    },
                                    children: /* @__PURE__ */ e(f, {
                                        children: /* @__PURE__ */ i(ye, {
                                            space: 16,
                                            children: [
                                                /* @__PURE__ */ e(se, {
                                                    children: /* @__PURE__ */ e(ce, {
                                                        children: n.map((M, g)=>/* @__PURE__ */ e(le, _object_spread({}, M), g))
                                                    })
                                                }),
                                                c && /* @__PURE__ */ e(Ee, {
                                                    paddingBottom: 16,
                                                    children: c
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                    })
                })
            })
        ]
    }) : V;
}, un = (param)=>{
    let { onBack: n, title: a, titleAs: t, right: r, isInverse: o = !1, topFixed: s = !0, paddingX: c = 0, withBorder: l = !0 } = param;
    const { texts: p } = C(), m = /* @__PURE__ */ e(v, {
        right: r,
        children: /* @__PURE__ */ i(N, {
            space: 24,
            alignItems: "center",
            children: [
                n && /* @__PURE__ */ e(ie, {
                    "aria-label": p.backNavigationBar,
                    onPress: n,
                    Icon: oe,
                    bleedLeft: !0,
                    bleedRight: !0
                }),
                /* @__PURE__ */ e(_, {
                    regular: !0,
                    truncate: !0,
                    as: t,
                    children: a
                })
            ]
        })
    });
    return /* @__PURE__ */ i(S, {
        isInverse: o,
        children: [
            /* @__PURE__ */ e(A, {
                topFixed: s,
                withBorder: l,
                isInverse: o,
                dataAttributes: {
                    "component-name": "NavigationBar"
                },
                children: s ? /* @__PURE__ */ e(f, {
                    children: m
                }) : /* @__PURE__ */ e("div", {
                    className: W({
                        width: "100%"
                    }),
                    style: {
                        padding: `0 ${c}px`
                    },
                    children: m
                })
            }),
            s && /* @__PURE__ */ e("div", {
                className: T
            })
        ]
    });
}, pn = (param)=>{
    let { logo: n, right: a, isInverse: t = !1, topFixed: r = !0, withBorder: o = !0 } = param;
    return n = n !== null && n !== void 0 ? n : /* @__PURE__ */ e(z, {
        size: {
            mobile: 40,
            desktop: 48
        }
    }), /* @__PURE__ */ i(S, {
        isInverse: t,
        children: [
            /* @__PURE__ */ e(A, {
                topFixed: r,
                withBorder: o,
                isInverse: t,
                dataAttributes: {
                    "component-name": "FunnelNavigationBar"
                },
                children: /* @__PURE__ */ e(f, {
                    children: /* @__PURE__ */ e(ue, {
                        template: "10",
                        children: /* @__PURE__ */ e(v, {
                            right: a,
                            children: n
                        })
                    })
                })
            }),
            r && /* @__PURE__ */ e("div", {
                className: T
            })
        ]
    });
}, hn = (param)=>{
    let { children: n } = param;
    return /* @__PURE__ */ e("div", {
        className: U,
        "data-component-name": "NavigationBarActionGroup",
        children: /* @__PURE__ */ e(N, {
            space: 24,
            alignItems: "center",
            children: n
        })
    });
}, gn = (_param)=>{
    var { children: n } = _param, a = _object_without_properties(_param, [
        "children"
    ]);
    const t = de();
    return /* @__PURE__ */ e(P, _object_spread_props(_object_spread({}, a), {
        className: u(W({
            border: "none",
            background: "transparent",
            padding: 0
        }), U, j[t ? "inverse" : "default"]),
        dataAttributes: {
            "component-name": "NavigationBarAction"
        },
        children: /* @__PURE__ */ e(N, {
            space: 16,
            alignItems: "center",
            children: x.Children.map(n, (r)=>typeof r == "string" ? /* @__PURE__ */ e(ee, {
                    regular: !0,
                    color: "inherit",
                    children: r
                }) : r)
        })
    }));
};
export { pn as FunnelNavigationBar, mn as MainNavigationBar, un as NavigationBar, gn as NavigationBarAction, hn as NavigationBarActionGroup };
